// Claude: alpha-tester feedback — "translate the 'About us', 'Contact us' and the user manual to
// Claude: all user interface languages where it is not done yet. Leave in English for those
// Claude: languages that you are not comfortable [translating]." Deliberately a smaller set than
// Claude: the 13 interface-UI languages (i18n.js): those are short labels, where an approximate
// Claude: translation is low-stakes and easy to spot-check; About us/Contact us/the user manual
// Claude: are long-form prose, where translation quality actually matters and reliably producing it
// Claude: for the Southern African Bantu languages isn't something to trust an LLM's fluency for.
export const TRANSLATED_CONTENT_LANGUAGES = ['af', 'fr', 'pt'];

// Claude: SharedStateContext's interfaceLanguage defaults to the literal string 'Eng' (not the
// Claude: 'en' the language-switcher dropdown itself sets) — treated as English here too, rather
// Claude: than falling through unmatched. That mismatch used to be a real bug: About.js's own
// Claude: check compared interfaceLanguage to the literal "Eng" and fell back to the Afrikaans
// Claude: content otherwise, so every interface language *except* that exact default state — French,
// Claude: Portuguese, isiZulu, the language switcher's own "en" for English, all of it — silently
// Claude: showed the About page in Afrikaans.
export function pickContentLanguage(interfaceLanguage) {
  const normalized = interfaceLanguage === 'Eng' ? 'en' : interfaceLanguage;
  return TRANSLATED_CONTENT_LANGUAGES.includes(normalized) ? normalized : 'en';
}
